import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children, onLogout }) => {
  return (
    <div className="min-h-screen bg-[#0f0f15]">
      <Header onLogout={onLogout} />
      <Sidebar />
      <main className="ml-[180px] pt-[60px] min-h-screen">
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
